
import { Record, Union } from "../fable_modules/fable-library-js.5.0.0/Types.js";
import { Response_SessionReport_$reflection } from "../StenaWeather.WeatherServiceUI.Shared/SessionDetails/API.js";
import { ServerError_$reflection } from "../StenaWeather.WeatherServiceUI.Shared/Errors.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.5.0.0/Result.js";
import { record_type, bool_type, option_type, list_type, string_type, class_type, union_type } from "../fable_modules/fable-library-js.5.0.0/Reflection.js";
import { empty, ofArray, map, singleton } from "../fable_modules/fable-library-js.5.0.0/List.js";
import { PageTitle_title, ErrorView_Cmd_ofError } from "../SharedView.js";
import { Cmd_none } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { onSessionDetailsAPI, Cmd_OfAsync_eitherAsResult } from "../Server.js";
import { createElement } from "react";
import React from "react";
import { UseElmishHelper_programWithCustomErrorHandler, React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.5.0.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { HtmlHelper_createElement } from "../fable_modules/Feliz.3.3.3/Html.fs.js";
import { collect, singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0/Seq.js";
import { ofList } from "../fable_modules/fable-library-js.5.0.0/Map.js";
import { comparePrimitives } from "../fable_modules/fable-library-js.5.0.0/Util.js";
import { BreadCrumbsModule_View, CrumbModule_View, ReactRouterCrumb_View } from "../Components/StenaWebUI/Elements/Breadcrumbs.js";
import { LoadingScreenModule_View } from "../Components/StenaWebUI/Panels/LoadingScreen.js";
import { TextModule_View } from "../Components/StenaWebUI/Core/Text.js";
import { WhiteSpaceType, UserSelectType, TextSize, TextVariant } from "../Components/StenaWebUI/Core/Text.js";
import { ColumnModule_View } from "../Components/StenaWebUI/Core/Column.js";

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadSessionReport", "OnSessionReportLoaded"];
    }
}

export function Msg_$reflection() {
    return union_type("StenaWeather.WeatherServiceUI.Client.Pages.SessionReport.Msg", [], Msg, () => [[], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Response_SessionReport_$reflection(), ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", Response_SessionReport_$reflection()]], [["ErrorValue", ServerError_$reflection()]]])]]]);
}

export class State extends Record {
    constructor(SessionId, Report, IsLoading) {
        super();
        this.SessionId = SessionId;
        this.Report = Report;
        this.IsLoading = IsLoading;
    }
}

export function State_$reflection() {
    return record_type("StenaWeather.WeatherServiceUI.Client.Pages.SessionReport.State", [], State, () => [["SessionId", class_type("System.Guid")], ["Report", option_type(list_type(string_type))], ["IsLoading", bool_type]]);
}

export function init(sessionId) {
    return [new State(sessionId, undefined, true), singleton((dispatch) => {
        dispatch(new Msg(0, []));
    })];
}

export function update(msg, state) {
    if (msg.tag === 1) {
        const result = msg.fields[0];
        if (result.tag === 1) {
            return [new State(state.SessionId, state.Report, false), ErrorView_Cmd_ofError(result.fields[0])];
        }
        else {
            return [new State(state.SessionId, result.fields[0].Text, false), Cmd_none()];
        }
    }
    else {
        return [new State(state.SessionId, state.Report, true), Cmd_OfAsync_eitherAsResult(() => onSessionDetailsAPI((x) => x.GetSessionReport(state.SessionId)), (Item) => (new Msg(1, [Item])))];
    }
}

export function SessionReportView($props) {
    let init_1;
    const sessionId = $props.sessionId;
    const state_1 = ((init_1 = init(sessionId), React_useElmish_Z6C327F2E(() => UseElmishHelper_programWithCustomErrorHandler(undefined, ProgramModule_mkProgram(() => init_1, update, (_arg, _arg_1) => {
    })), undefined, [sessionId])))[0];
    return HtmlHelper_createElement("div", ofArray([["style", {
        padding: 20,
    }], ["children", toList(delay(() => {
        let p_1_4, p_1_1, p_1_2, p_1_3;
        return append(singleton_1((p_1_4 = ofList(map((value_6) => value_6, singleton(["children", ofArray([(p_1_1 = ofList(map((value_3) => value_3, ofArray([["label", "List of vessels"], ["dest", "/vessels"]])), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        }), createElement(ReactRouterCrumb_View, {
            p: p_1_1,
        })), (p_1_2 = ofList(map((value_4) => value_4, ofArray([["label", "Session details"], ["dest", `/sessions/${sessionId}`]])), {
            Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
        }), createElement(ReactRouterCrumb_View, {
            p: p_1_2,
        })), (p_1_3 = ofList(map((value_5) => value_5, singleton(["label", "Session report"])), {
            Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
        }), createElement(CrumbModule_View, {
            p: p_1_3,
        }))])])), {
            Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
        }), createElement(BreadCrumbsModule_View, {
            p: p_1_4,
        }))), delay(() => append(singleton_1(PageTitle_title("Session Report", "Detailed session report information")), delay(() => {
            let p_1_5, p_1_7;
            if (state_1.IsLoading) {
                return singleton_1((p_1_5 = ofList(map((value_7) => value_7, singleton(["text", "Loading session report..."])), {
                    Compare: (x_4, y_4) => (comparePrimitives(x_4, y_4) | 0),
                }), createElement(LoadingScreenModule_View, {
                    p: p_1_5,
                })));
            }
            else {
                const matchValue = state_1.Report;
                if (matchValue == null) {
                    return singleton_1(TextModule_View(ofList(map((value_12) => value_12, ofArray([["children", "No report data available."], ["variant", new TextVariant(0, [])], ["size", new TextSize(1, [])]])), {
                        Compare: (x_7, y_7) => (comparePrimitives(x_7, y_7) | 0),
                    })));
                }
                else {
                    const textLines = matchValue;
                    return singleton_1((p_1_7 = ofList(map((value_10) => value_10, singleton(["children", toList(delay(() => collect((line) => append(singleton_1(TextModule_View(ofList(map((value_9) => value_9, ofArray([["children", line], ["variant", new TextVariant(0, [])], ["size", new TextSize(1, [])], ["userSelect", new UserSelectType(6, [])], ["whiteSpace", new WhiteSpaceType(11, [])]])), {
                        Compare: (x_5, y_5) => (comparePrimitives(x_5, y_5) | 0),
                    }))), delay(() => singleton_1(HtmlHelper_createElement("br", empty())))), textLines)))])), {
                        Compare: (x_6, y_6) => (comparePrimitives(x_6, y_6) | 0),
                    }), createElement(ColumnModule_View, {
                        p: p_1_7,
                    })));
                }
            }
        }))));
    }))]]));
}

